module.exports = __webpack_public_path__ + "static/img/meeting_item3.90db367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/meeting_item3.png
// module id = Hi1s
// module chunks = 2